import { useMutation, useQueryClient } from '@northladder/services';

import { BIDS_API } from '../bidsAPIClient';

import { FETCH_ALL_UPLOADED_BIDS_KEY } from './useSearchUploadedBidsQuery';

/**
 * Mutation key for uploading dealer bid book (excel) file.
 */
const MUT_UPLOAD_DEALER_BID_BOOK = 'upload-dealer-bid-book-mutation-key';

interface IUseUploadDealerBidBookMutationProps {
  onSuccess?: () => void;
}

/**
 * Hook to upload dealer bid book excel file to endpoint: /assets/import/active-asset-bids
 * @deprecated - Use `useUploadBidBookTemplateMutation` instead.
 */
export const useUploadDealerBidBookMutation = ({
  onSuccess,
}: IUseUploadDealerBidBookMutationProps = {}) => {
  const queryClient = useQueryClient();

  const { error, isError, isPending, mutate } = useMutation({
    mutationKey: [MUT_UPLOAD_DEALER_BID_BOOK],
    networkMode: 'always',
    mutationFn: BIDS_API.uploadBidBook,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [FETCH_ALL_UPLOADED_BIDS_KEY],
      });

      if (onSuccess) onSuccess();
    },
  });

  return {
    error,
    isError,
    isUploading: isPending,
    uploadDealerBidBook: mutate,
  };
};
